<template>
  <div class="flex gap-2 p-4">
    <VaIconMenuCollapsed
      class="cursor-pointer"
      :class="{ 'x-flip': !isSidebarMinimized }"
      :color="collapseIconColor"
      @click="isSidebarMinimized = !isSidebarMinimized"
    />

    <nav class="flex items-center">
      <VaBreadcrumbs>
        <VaBreadcrumbsItem :label="NavigationRoutes.root.name" :to="{ name: NavigationRoutes.root.href }" disabled />
        <VaBreadcrumbsItem
          v-for="(breadcrumb, i) in breadcrumbs"
          :key="'breadcrumb_' + i"
          :label="breadcrumb"
          disabled
        />
      </VaBreadcrumbs>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useColors } from 'vuestic-ui'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '@/stores/global-store'
import VaIconMenuCollapsed from '../icons/VaIconMenuCollapsed.vue'
import NavigationRoutes from '../sidebar/navigationRoutes'

const { isSidebarMinimized } = storeToRefs(useGlobalStore())

const route = useRoute()

const { getColor } = useColors()

const collapseIconColor = computed(() => getColor('secondary'))
const breadcrumbs = computed(() => {
  const paths = route.path.split('/').slice(1)
  if (paths.length > 1) {
    const currentRoutes = NavigationRoutes.routes.find(
      (navRoute) => navRoute.childrenRoutes?.some(({ href }) => href === paths.slice(-1)[0]),
    )
    return [currentRoutes?.name, currentRoutes?.childrenRoutes?.find(({ href }) => href === paths.slice(-1)[0])?.name]
  }
  const currentRoute = NavigationRoutes.routes.find((navRoute) => navRoute.href === paths.slice(-1)[0])
  return [currentRoute?.name]
})
</script>

<style lang="scss" scoped>
.x-flip {
  transform: scaleX(-100%);
}
</style>
